class ArchiveProduct {
	constructor() {
		this.page = document.querySelector(".post-type-archive-product");
		if (!this.page) {
			return;
		}

		this.noResultMessage = document.querySelector(".no-result-message");
		this.products = document.querySelectorAll(".product-col");

		this.initFilters();
		this.applyGetFilters();
	}


	initFilters() {
		document.querySelector(".product-type-filter").addEventListener("customselect", (e) => {
			if (e.detail === "all") {
				this.typeFilter = null;
			} else {
				this.typeFilter = e.detail;
			}
			this.filterProducts(e.detail);
		});

		document.querySelector(".working-environment-filter").addEventListener("customselect", (e) => {
			if (e.detail === "all") {
				this.environmentFilter = null;
			} else {
				this.environmentFilter = e.detail;
			}
			this.filterProducts(e.detail);
		});
	}

	filterProducts() {
		let productToDisplay = 0;
		this.products.forEach(col => {
			col.classList.add("d-none");
			const product = col.querySelector(".card-product");
			if (this.typeFilter) {
				if (!product.dataset.type.toLowerCase().includes(this.typeFilter.toLowerCase())) {
					return;
				}
			}
			if (this.environmentFilter) {
				if (!product.dataset.environment.toLowerCase().includes(this.environmentFilter.toLowerCase())) {
					return;
				}
			}
			productToDisplay++;
			col.classList.remove("d-none");
		});
		if (productToDisplay === 0) {
			this.noResultMessage.classList.remove("d-none");
		} else {
			this.noResultMessage.classList.add("d-none");
		}
		ScrollTrigger.refresh();
	}

	applyGetFilters() {
		const urlParams = new URLSearchParams(window.location.search);
		const productType = urlParams.get('product-type');
		if (productType) {
			const value = document.querySelector(`.product-type-filter [data-value="${productType}"]`);
			if (value) {
				setTimeout(function () {
					value.click();
				}, 0);
			}
		}
		const workingEnvironment = urlParams.get('we');
		if (workingEnvironment) {
			const value = document.querySelector(`.working-environment-filter [data-value="${workingEnvironment}"]`);
			if (value) {
				setTimeout(function () {
					value.click();
				}, 0);
			}
		}
	}
}
